import React from 'react';
import Top from '../common/fixedbar';
import { days, getDaysInMonth, monthsFull,getDateStringFromDate,getMobileOperatingSystem,getIosFormattedDate } from '../common/helper';
import Close from '../common/icons/close';
import { getSearchUrl } from './modify';
import { baseCss } from '../common/css';
import './calendar.css';

const Calendar = ({ journeyDate, onClose, numOfMons = 6, onSel, className, hideCalHeaderTop = false }) => {
    const renderData = [];
    const today = new Date();
    const month = today.getMonth();
    let weeks = [...days];
    weeks.push(weeks.shift());
    for (let i = 0; i < numOfMons; i++) {
        renderData.push({
            month: month + i > 11 ? month + i - 12 : month + i,
            year: month + i > 11 ? today.getFullYear() + 1 : today.getFullYear(),
            days: getDaysInMonth(
                month + i > 11 ? month + i - 12 : month + i,
                month + i > 11 ? today.getFullYear() + 1 : today.getFullYear(),
                -1
            )
        })
    }

    const sel = (date, month, year) => {
        const source = getMobileOperatingSystem();
        
        const dt = new Date(`${year}-${month + 1}-${date}`);

        if (source === "IOS_WEB") {
            const ymd = `${year}-${month < 10 ? `0${month + 1}` : month + 1}-${date} 00:00:00`;
            const iosdt = getIosFormattedDate(ymd);
            onSel(getDateStringFromDate(iosdt));
        } else {
           onSel(getDateStringFromDate(dt));
        }
    }

    return (
        <React.Fragment>
            <Top className={`cal--header ${className}`} style={baseCss.primaryBackground}>
                {
                    hideCalHeaderTop ? "" :
                        <div className='header cal--header-top'>
                            <Close onClick={onClose} className='cal--header-top-close' />
                            <div>Journey Date</div>
                        </div>
                }

                <div className='cal--header-weeks'>
                    {
                        weeks.map(el => <div key={el} className='cal--header-weeks-text'>{el}</div>)
                    }
                </div>
            </Top>
            <div className='cal--content'>
                {
                    renderData.map(item => (
                        <div className='cal--content-wrapper' key={item.month}>
                            <div className='cal--content-wrapper-month'>{`${monthsFull[item.month]} ${item.year}`}</div>
                            <div className='cal--content-wrapper-days'>
                                {item.days.map((el, index) => renderDates(index, el, item.month, item.year, new Date(journeyDate), sel))}
                            </div>
                        </div>
                    ))
                }
            </div>
        </React.Fragment>
    )
}

const renderDates = (key, date, month, year, sel, selectDate) => {
    const curr = new Date();
    const isSelected = date === sel.getDate() && month === sel.getMonth();// && year === sel.getFullYear();
    const isPrevDate = month === curr.getMonth() && date < curr.getDate();
    const isWeekend = [5, 6, 12, 13, 19, 20, 26, 27, 33, 34].indexOf(key) > -1;
    return (
        <div key={key} className={`${isPrevDate ? 'cal--content-wrapper-days-disabled' : ''} ${isWeekend && 'cal--content-wrapper-days-weekend'}`}>
            <div
                onClick={() => selectDate(date, month, year)}
                className={`${isSelected ? 'cal--content-wrapper-days-sel' : ''}`}
                style={isSelected ? baseCss.primaryBackground : {}}
            >
                {date}
            </div>
        </div>
    )
}

export default Calendar;


// WEBPACK FOOTER //
// ./src/components/search/calendar.js